import { AlertBar2 } from "@/ui2/atoms/AlertBar";
import type { AlertProps } from "@/ui2/atoms/AlertBar";
import type { PatientDetails } from "@/core/types";

type Props = Omit<AlertProps, "variant" | "children"> & {
  eligibilityStatus?: string;
  firstName: PatientDetails["first_name"];
};

const ALERT_STATUSES = ["declined", "no_match"];

export function EligibilityAlertBanner({ eligibilityStatus, firstName, ...props }: Props) {
  if (!eligibilityStatus || !ALERT_STATUSES.includes(eligibilityStatus)) return null;

  return (
    <AlertBar2 variant="error" {...props}>
      <strong>
        Before scheduling {firstName}&apos;s next appointment, advise them to update insurance or
        contact Support.
      </strong>
    </AlertBar2>
  );
}
